<app-access-control-form
    *ngIf="!loading"
    [title]="'access_control.list.edit' | translate"
    [access]="access" 
    [submitLoading]="submitLoading"
    [isEditMode]="true"
    (submitForm)="handleSubmit($event)">
</app-access-control-form>
